import { gql } from '@apollo/client';
import ADTYPE from 'components/jobSubmission/adTypes';
import client from 'graphql/client';

const fetchAdvertPositionsGraphql = () => {
  const query = gql`
    query lists {
      lists {
        advertPositions {
          id
          name
        }
      }
    }
  `;
  return client.query({
    query,
    fetchPolicy: 'network-only',
  });
};

/* pricelist fetch */
const fetchPricelistGraphql = (payload) => {
  const params = {};
  const { variables } = payload;

  if (payload.recache) {
    params.fetchPolicy = 'network-only';
  }

  const query = gql`
    query adPriceList($currency: Currency!) {
      adPriceList(currency: $currency) {
        adType
        lengthInDays
        quote {
          price {
            amount
            currency
          }
          priceWithTax {
            amount
          }
        }
      }
    }
  `;

  return client.query({
    query,
    variables,
    ...params,
  });
};

const mutateCreateIncompleteJob = (payload) => {
  const params = {};
  const { variables } = payload;

  if (payload.recache) {
    params.fetchPolicy = 'network-only';
  }

  const mutation = gql`
    mutation createIncompleteJob(
      $durationInDays: Int
      $adType: AdType
      $siteVisibility: Int
      $projectId: Int
      $promoCode: String
      $addons: [String]
    ) {
      createIncompleteJob(
        durationInDays: $durationInDays
        adType: $adType
        siteVisibility: $siteVisibility
        projectId: $projectId
        promoCode: $promoCode
        addons: $addons
      )
    }
  `;

  return client.mutate({
    mutation,
    variables,
    ...params,
  });
};

const fetchPriceCalculationGraphQl = (payload) => {
  const query = gql`
    query adPriceCalculation(
      $currency: Currency!
      $adType: AdType
      $lengthInDays: Int
      $addOns: [AddOnTypes]
      $adPlacementType: AdPlacementType
      $discountPercentage: Float
      $adCount: Int
    ) {
      adPriceCalculation(
        currency: $currency
        adPriceRequests: [
          {
            adType: $adType
            lengthInDays: $lengthInDays
            adCount: $adCount
            addOns: $addOns
            adPlacementType: $adPlacementType
            discountPercentage: $discountPercentage
          }
        ]
      ) {
        price {
          amount
          currency
        }
        tax {
          amount
          currency
        }
        priceWithTax {
          amount
          currency
        }
        priceWithoutDiscount {
          amount
          currency
        }
        addOns {
          name
          price {
            amount
            currency
          }
          tax {
            amount
            currency
          }
          priceWithTax {
            amount
            currency
          }
        }
      }
    }
  `;

  return client.query({
    query,
    variables: {
      currency: payload.currency,
      adType: ADTYPE.GRAPHQL[payload.adType],
      lengthInDays: payload.lengthInDays,
      addOns: payload.addOns,
      adPlacementType: payload.adPlacementType,
      discountPercentage: payload.discountPercentage,
      adCount: payload.adCount || 1,
    },
  });
};

export default fetchPricelistGraphql;
export { fetchAdvertPositionsGraphql, fetchPriceCalculationGraphQl, mutateCreateIncompleteJob };
